const u = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  asparagus: u("1595855759920-86582396756a"),
  flatlay: u("1566385101042-1a0aa0c1268c"),
  stillLifeDark: u("1518843875459-f738682238a6"),
  saladBowl: u("1540420773420-3366772f4999"),
  market: u("1542838132-92c53300491e"),
  cooking: u("1466637574441-749b8f19452f"),
  citrus: u("1610832958506-aa56368176cf"),
  wheatField: u("1464226184884-fa280b87c399"),
  lettuceField: u("1471193945509-9ad0617afabf"),
  greenHills: u("1615729947596-a598e5de0ab3"),
  earthSeedling: u("1542601906990-b4d3fb778b09"),
  labMicroscope: u("1532187863486-abf9dbad1b69"),
  labGlass: u("1576086213369-97a306d36557"),
  verticalFarm: u("1625246333195-78d9c38ad449"),
  greenhouse: u("1523348837708-15d4a09cfac2"),
  farmTech: u("1560493676-04071c5f467b"),
  fineDining: u("1414235077428-338989a2e8c0"),
  restaurantKitchen: u("1590779033100-9f60a05a013d"),
  chefPlating: u("1555244162-803834f70033"),
  kitchenCooking: u("1556910103-1c02745aae4d"),
};
